"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_2 = require("@nextui-org/react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var multiTextInput_1 = __importDefault(require("../../../../../controls/multiTextInput"));
var validateForm_1 = require("../../../../../helpers/validateForm/validateForm");
var console_1 = require("../../../../../reducers/slices/console");
var product_attribute_1 = require("../../../../../reducers/slices/products/product_attribute/product_attribute");
var create_product_attribute_thunk_1 = require("../../../../../reducers/slices/products/product_attribute/thunks/create_product_attribute_thunk");
var get_product_attribute_thunk_1 = require("../../../../../reducers/slices/products/product_attribute/thunks/get_product_attribute_thunk");
var update_product_attribute_thunk_1 = require("../../../../../reducers/slices/products/product_attribute/thunks/update_product_attribute_thunk");
var initialProductAttributeValues = {
    name: "",
    description: "",
    type: "",
    default_value: "",
    options: [],
};
var validationConfig = {
    name: {
        required: true,
        minLength: 2,
        maxLength: 50,
    },
    description: {
        required: false,
    },
    type: {
        required: true,
    },
    options: {
        required: true,
        dependOn: { key: "type", value: "LIST" },
    },
    default_value: {
        required: false,
    },
};
var attributeTypes = [
    { label: "Text", value: "TEXT" },
    { label: "Number", value: "NUMBER" },
    { label: "Boolean", value: "BOOLEAN" },
    { label: "Multiple Choice", value: "LIST" },
];
var ProductAttributeDetailsPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var product_attribute_id = (0, react_router_dom_1.useParams)().product_attribute_id;
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _a = react_1.default.useState(false), isInteracted = _a[0], setIsInteracted = _a[1];
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.productAttributeState; }), pagination = _b.pagination, selectedProductAttribute = _b.selectedProductAttribute, loading = _b.loading;
    var _c = (0, validateForm_1.validateForm)(selectedProductAttribute, {
        validationConfig: validationConfig,
        initialValues: initialProductAttributeValues,
        enabled: isInteracted,
    }), errors = _c.errors, isValid = _c.isValid;
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, _id, name_1, description, type, options, default_value;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(selectedProductAttribute === null || selectedProductAttribute === void 0 ? void 0 : selectedProductAttribute._id)) return [3 /*break*/, 2];
                    _id = selectedProductAttribute._id, name_1 = selectedProductAttribute.name, description = selectedProductAttribute.description, type = selectedProductAttribute.type, options = selectedProductAttribute.options, default_value = selectedProductAttribute.default_value;
                    return [4 /*yield*/, dispatch((0, update_product_attribute_thunk_1.update_product_attribute_thunk)({
                            _id: _id,
                            name: name_1,
                            description: description,
                            type: type,
                            options: options,
                            default_value: default_value,
                        }))];
                case 1:
                    response = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, dispatch((0, create_product_attribute_thunk_1.create_product_attribute_thunk)(selectedProductAttribute))];
                case 3:
                    response = _b.sent();
                    _b.label = 4;
                case 4:
                    if ((_a = response === null || response === void 0 ? void 0 : response.payload) === null || _a === void 0 ? void 0 : _a.success) {
                        dispatch((0, product_attribute_1.setSelectedProductAttribute)(null));
                        navigate(-1);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var _setProductAttribute = function (value) {
        dispatch((0, product_attribute_1.setSelectedProductAttribute)(__assign(__assign(__assign({}, initialProductAttributeValues), selectedProductAttribute), value)));
        if (!isInteracted)
            setIsInteracted(true);
    };
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Product Attribute Details"));
    }, []);
    (0, react_1.useEffect)(function () {
        if (user._id && product_attribute_id) {
            dispatch((0, get_product_attribute_thunk_1.get_product_attribute_thunk)({
                _id: product_attribute_id,
            }));
        }
    }, [user, product_attribute_id]);
    var renderValueInput = function () {
        switch (selectedProductAttribute === null || selectedProductAttribute === void 0 ? void 0 : selectedProductAttribute.type) {
            case "TEXT":
                return ((0, jsx_runtime_1.jsx)(react_2.Input, { label: "Default Value", placeholder: "Enter default text value", maxLength: 50, value: selectedProductAttribute === null || selectedProductAttribute === void 0 ? void 0 : selectedProductAttribute.default_value, onChange: function (e) { return _setProductAttribute({ default_value: e.target.value }); }, className: "max-w-full" }));
            case "NUMBER":
                return ((0, jsx_runtime_1.jsx)(react_2.Input, { type: "number", maxLength: 50, label: "Default Value", placeholder: "Enter default numeric value", value: String(selectedProductAttribute === null || selectedProductAttribute === void 0 ? void 0 : selectedProductAttribute.default_value), onChange: function (e) { return _setProductAttribute({ default_value: Number(e.target.value) }); }, className: "max-w-full" }));
            case "BOOLEAN":
                return ((0, jsx_runtime_1.jsxs)(react_2.Select, __assign({ label: "Default Value", placeholder: "Select default boolean value", selectedKeys: [String(selectedProductAttribute === null || selectedProductAttribute === void 0 ? void 0 : selectedProductAttribute.default_value)], onChange: function (e) { return _setProductAttribute({ default_value: e.target.value }); }, className: "max-w-full" }, { children: [(0, jsx_runtime_1.jsx)(react_2.SelectItem, __assign({ value: "true" }, { children: "True" }), "true"), (0, jsx_runtime_1.jsx)(react_2.SelectItem, __assign({ value: "false" }, { children: "False" }), "false")] })));
            case "LIST":
                return ((0, jsx_runtime_1.jsx)(multiTextInput_1.default, { options: selectedProductAttribute === null || selectedProductAttribute === void 0 ? void 0 : selectedProductAttribute.options, callback: function (options) {
                        return _setProductAttribute({
                            options: options,
                        });
                    } }));
            default:
                return null;
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "max-w-7xl mx-auto" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "mb-6" }, { children: (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ variant: "light", startContent: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faArrowLeft }), onPress: function () { return navigate(-1); } }, { children: "Back to Product Attributes" })) })), (0, jsx_runtime_1.jsxs)(react_2.Card, __assign({ className: "w-full" }, { children: [(0, jsx_runtime_1.jsxs)(react_2.CardHeader, __assign({ className: "flex justify-between items-center px-6 py-4" }, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: "text-xl font-semibold" }, { children: "Product Attribute Details" })), (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ startContent: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCloud }), color: "primary", variant: "solid", isLoading: loading, isDisabled: !isValid, onPress: handleSave }, { children: product_attribute_id ? "Update Attribute" : "Save Attribute" }))] })), (0, jsx_runtime_1.jsx)(react_2.Divider, {}), (0, jsx_runtime_1.jsx)(react_2.CardBody, __assign({ className: "gap-6 p-6" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "grid grid-cols-1 md:grid-cols-2 gap-6" }, { children: [(0, jsx_runtime_1.jsx)(react_2.Input, { label: "Attribute Name", maxLength: 50, placeholder: "Enter attribute name", value: selectedProductAttribute === null || selectedProductAttribute === void 0 ? void 0 : selectedProductAttribute.name, errorMessage: errors.name, isInvalid: !!errors.name, onChange: function (e) { return _setProductAttribute({ name: e.target.value }); }, className: "max-w-full" }), (0, jsx_runtime_1.jsx)(react_2.Select, __assign({ label: "Attribute Type", placeholder: "Select attribute type", selectedKeys: (selectedProductAttribute === null || selectedProductAttribute === void 0 ? void 0 : selectedProductAttribute.type) ? [selectedProductAttribute.type] : [], errorMessage: errors.type, isInvalid: !!errors.type, onChange: function (e) { return _setProductAttribute({ type: e.target.value, default_value: null }); }, className: "max-w-full" }, { children: attributeTypes.map(function (type) { return ((0, jsx_runtime_1.jsx)(react_2.SelectItem, __assign({ value: type.value }, { children: type.label }), type.value)); }) })), (0, jsx_runtime_1.jsx)(react_2.Textarea, { label: "Description", placeholder: "Enter attribute description", maxLength: 150, value: (selectedProductAttribute === null || selectedProductAttribute === void 0 ? void 0 : selectedProductAttribute.description) || "", onChange: function (e) { return _setProductAttribute({ description: e.target.value }); }, className: "max-w-full md:col-span-2" }), (selectedProductAttribute === null || selectedProductAttribute === void 0 ? void 0 : selectedProductAttribute.type) && (0, jsx_runtime_1.jsx)("div", __assign({ className: "md:col-span-2" }, { children: renderValueInput() }))] })) }))] }))] })));
};
exports.default = ProductAttributeDetailsPage;
